import axios from 'axios';
import React, { useState } from 'react';
import { DNA, Oval, Triangle } from 'react-loader-spinner';
import { Link } from 'react-router-dom';
import { api_url } from '../utils/Config';
import { toast } from 'react-toastify';

const ForgotPasswordForm = () => {
    const [email, setEmail] = useState('')
    const [error, setError] = useState('')
    const [loading, setLoading] = useState(false)
    const [status, setStatus] = useState('')

    const handleSendEmail = async (e) => {
        e.preventDefault();
        const form = {
            email
        };
        try {
            setLoading(true);
            const response = await axios.post(`${api_url}/forgot-password`, form, {
                headers: {
                    "Content-Type": "application/json"
                }
            });
            if (response.status === 200) {
                toast.success('The link has been sent to your email');
                setStatus('The link has been sent to your email');
                setTimeout(() => {
                    setStatus('');
                }, 6000);
            }
        } catch (error) {
            setError(error?.response?.data?.error);
            toast.error('An error occurred');
            setTimeout(() => {
                setError('');
            }, 3000);
        } finally {
            setLoading(false);
            setEmail('');
        }
    };


    return (
        <div className='w-screen sm:max-w-md mx-auto'>

            <form className='space-y-4 md:space-y-4' >
                <div>
                    <p className='text-xl font-medium text-neutral-600 text-center mb-4 sm:mb-2 font-lufga'>Forgot Password?</p>
                    <p className='text-sm text-neutral-600 text-center font-lufga'>Enter the email you registered with and we will send you a link to reset your password</p>
                </div>
                <div>
                    <label
                        htmlFor='email'
                        className='block font-lufga mb-2 text-sm font-medium text-gray-900 '
                    >
                        Email
                    </label>
                    <input
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        type='email'
                        name='email'
                        id='email'
                        className='bg-gray-50 border border-gray-300 text-gray-900 text-xs sm:text-sm rounded-lg focus:outline-none  block w-full p-2.5 '
                        placeholder='admin@dev.com'
                        required
                    />
                </div>
                {status ? <div>
                    <p className="bg-green-300 font-lufga rounded-md shadow-md px-2 py-1 text-xs text-center ">{status}</p>
                </div> : error ? <div>
                    <p className="bg-red-300 rounded-md font-lufga text-center shadow-md px-2 py-1 text-sm ">
                        {typeof error === 'string' ? error : (
                            Object.keys(error).map((key) => (
                                Array.isArray(error[key]) ? error[key][0] : error[key]
                            ))
                        )}
                    </p>
                </div> : null}

                <div className='flex justify-end'>
                    <button
                         onClick={handleSendEmail}
                        disabled={loading}
                        className='font-lufga text-white bg-[#1330C5] hover:opacity-90 focus:outline-none rounded-md shadow-md text-base px-5 py-2 sm:px-10 sm:py-3 text-center'
                    >
                        {loading ? (
                            <div className="">
                                <Oval
                                    visible={true}
                                    height="20"
                                    width="20"
                                    color="#ffff"
                                    ariaLabel="oval-loading"
                                    wrapperStyle={{}}
                                    wrapperClass=""
                                />
                            </div>
                        ) : 'Send Email'}
                    </button>
                </div>
                <div className='flex justify-between'>
                    <Link to='/'>
                        <p className='hover:underline font-lufga cursor-pointer text-sm text-blue-800'>Go back</p>
                    </Link>

                </div>
            </form>
        </div>
    );
}

export default ForgotPasswordForm;
